module.exports = __webpack_public_path__ + "img/onsiteDisposal2.a0530033.webp";